module.exports = __webpack_public_path__ + "img/1294436798.9bdc8651.jpg";